import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useSearchParams } from 'react-router';

import { FullPage } from '@/components/page';
import { Link, Text } from '@/components/typography';
import { isStageEnvironment } from '@/helper/environment';
import { setPendingSignInMethod } from '@/helper/user-preferences';
import { ROUTES } from '@/router';

import EmailSignInForm from '../EmailSignInForm';
import SignInPanel from '../SignInPanel';

const SignInEmail = () => {
  const [searchParams] = useSearchParams();

  return (
    <FullPage title={t`Sign In with Email`}>
      <SignInPanel
        title={t`Sign In with Email`}
        description={
          <Trans>
            We'll send a one-time access link to your business email so you can sign in without a
            password.
          </Trans>
        }
        footer={
          <>
            {!isStageEnvironment && (
              <Text variant="caption1" color="grey">
                <Trans>
                  Already have a password?{' '}
                  <Link
                    variant="caption1"
                    color="aqua"
                    to={`${ROUTES.signInPassword.path}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`}
                  >{t`Sign in with password`}</Link>
                </Trans>
              </Text>
            )}
            <Text variant="caption1" color="grey">
              <Trans>
                Prefer a different method?{' '}
                <Link
                  variant="caption1"
                  color="aqua"
                  to={`${ROUTES.signIn.path}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`}
                >
                  Sign in another way
                </Link>
              </Trans>
            </Text>
          </>
        }
        showGap
      >
        <EmailSignInForm onStartAuth={() => setPendingSignInMethod('email')} />
      </SignInPanel>
    </FullPage>
  );
};

export default SignInEmail;
